// Shared "who's playing on this booking" logic for the two admin/customer
// list surfaces (My Bookings' BookingDetailsDialog and the admin Manage
// Bookings detail panel). The Getaway Pass PDF (generateGolfPass.js) has
// its own equivalent inline logic — kept separate there since it also
// drives PDF layout math, but the lead-detection rule is the same:
// whoever made the booking (customerName) is always the lead, always
// first, regardless of what order golferNames happens to be stored in.

/**
 * @param {Record<string, any>} booking
 * @returns {{ name: string, isLead: boolean, placeholder?: boolean }[]}
 */
export function getGolferRoster(booking = {}) {
  const rawNames = Array.isArray(booking.golferNames)
    ? booking.golferNames
    : Array.isArray(booking.players)
      ? booking.players.map((p) => p?.name ?? p)
      : [];
  const names = rawNames.map((n) => String(n).trim()).filter(Boolean);
  const lead = (booking.customerName || names[0] || "Lead Golfer").trim();
  const others = names.filter((n) => n.toLowerCase() !== lead.toLowerCase());
  const numPlayers = Number(booking.numPlayers ?? (names.length || 1));

  const roster = [
    { name: lead, isLead: true },
    ...others.map((name) => ({ name, isLead: false })),
  ];
  // Older bookings made before golfer-name capture existed only have a
  // player count, no names — pad with generic placeholders so the roster
  // always has exactly numPlayers entries.
  while (roster.length < numPlayers) {
    roster.push({
      name: `Golfer ${roster.length + 1}`,
      isLead: false,
      placeholder: true,
    });
  }
  return roster;
}
